import React from "react";

import AuthorizationForm from "../../modules/Auth";

const Authorization = () => <AuthorizationForm />;

export default Authorization;
